module.exports = __webpack_public_path__ + "static/img/bg_Bill_texture@2x.b19e251.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applicationDiscount/bg_Bill_texture@2x.png
// module id = BonJ
// module chunks = 69